export const OVERVIEW = { en: 'Overview', th: 'ข้อมูลคอนโด' }

export const ALL_UNITS = { en: 'All units', th: 'ยูนิตทั้งหมด' }

export const AVERAGE_PRICE = { en: 'Average price', th: 'ราคาเช่าเฉลี่ย' }

export const ROOM_STATUS = { en: 'Room status', th: 'สถานะที่พัก' }

export const ROOM_TYPE = { en: 'Roomtype', th: 'ประเภทห้อง' }

export const ROOM_SIZE = { en: 'Size (sq.m.)', th: 'ขนาด (ตร.ม.)' }

export const FLOOR = { en: 'Floor', th: 'ชั้น' }

export const RENTAL_PRICE = { en: 'Rental price', th: 'ราคาเช่า' }

export const RENTAL_PRICE_WITH_UNIT = {
  en: 'Rental price (Baht)',
  th: 'ราคาเช่า',
}

export const FURNITURE = {
  en: 'Furniture & Appliances',
  th: 'เฟอร์นิเจอร์ และ เครื่องใช้ไฟฟ้า',
}

export const NEARBY_TYPES_PLACEHOLDER = {
  en: 'Select place types',
  th: 'เลือกประเภทสถานที่',
}

export const NO_NEARBY_PLACES = {
  en: 'Please select place types',
  th: 'กรุณาเลือกประเภทสถานที่',
}
